export const TRADING_ACTIVITY_SUMMARY_ROWS_ORDER = ['LONG', 'SHORT', 'NET', 'GROSS'];
